import {useMemo, useState} from "react";

const SQUARE_SIZE = 3;

function Square({ id, value, onSquareClick, winner, points }) {
    return <button className="square" onClick={onSquareClick} style={{
        color: winner && points?.includes(id) ? 'green' : 'black',
    }}>{value}</button>
}

function Board({ xIsNext, squares, onPlay }) {
    const { winner, points } = calculateWinner(squares);

    function handleClick(i) {
        if (squares[i] || winner) {
            return;
        }

        const nextSquares = squares.slice();

        if (xIsNext) {
            nextSquares[i] = 'X';
        } else {
            nextSquares[i] = 'O';
        }

        onPlay(nextSquares);
    }

    let status;

    const rendering = useMemo(() => {
        const result = [];

        for (let i = 0; i < SQUARE_SIZE; i++) {
            result.push(
                <div key={i} className="board-row">
                    {Array.from({length: SQUARE_SIZE}).map((_, j) => (
                        <Square key={i * 3 + j}
                                id={i * 3 + j}
                                onSquareClick={() => handleClick(i * 3 + j)}
                                value={squares[i * 3 + j]}
                                winner={winner}
                                points={points}
                        />
                    ))}
                </div>
            );
        }

        return result;
    }, [squares, winner, points]);

    if (winner) {
        status = '승자: ' + winner;
    } else {
        status = '다음 플레이어: ' + (xIsNext ? 'X' : 'O');
    }

    return (
        <>
            <div className="status">{status}</div>
            { rendering }
        </>
    );
}

export default function Game() {
    const [history, setHistory] = useState([Array(9).fill(null)]);
    const [currentMove, setCurrentMove] = useState(0);
    const currentSquares = history[currentMove];
    const [isAscending, setIsAscending] = useState(true);

    const xIsNext = currentMove % 2 === 0;

    function handlePlay(nextSquares) {
        const nextHistory = [...history.slice(0, currentMove + 1), nextSquares];
        setHistory(nextHistory);
        setCurrentMove(nextHistory.length - 1);
    }

    function jumpTo(nextMove) {
        setCurrentMove(nextMove);
    }

    const moves = history.map((squares, move) => {
        console.log('squares', squares);

        let description;

        const calculateUserPick = (move) => {
            let answer = null;
            const nowSquares = history[move];
            const prevSquares = history[move - 1];

            for (let i = 0; i < squares.length; i++) {
                if (nowSquares[i] !== prevSquares[i]) {
                    answer = i;
                    break;
                }
            }

            const row = Math.floor(answer / SQUARE_SIZE);
            const col = answer % SQUARE_SIZE;
            return [row + 1, col + 1];
        }

        if (move > 0) {
            const [row, col] = calculateUserPick(move);
            description = '# ' + move + '로 이동하기 (' + row + ', ' + col + ')';
        } else {
            description = '시작지점으로 이동하기';
        }

        return (
            <li key={move}>
                <button onClick={() => jumpTo(move)}>{description}</button>
            </li>
        )
    });

    return (
        <div className="game">
            <div className="game-board">
                <div>당신은 {currentMove + 1}번째 순서에 있습니다...</div>
                <Board xIsNext={xIsNext} squares={currentSquares} onPlay={handlePlay} />
            </div>
            <div className="game-info">
                <ol><button onClick={() => setIsAscending(!isAscending)}>순서변경</button></ol>
                <ol>{isAscending ? moves : moves.reverse() }</ol>
            </div>
        </div>
    )
};

function calculateWinner(squares) {
    const lines = [
        [0, 1, 2],
        [3, 4, 5],
        [6, 7, 8],
        [0, 3, 6],
        [1, 4, 7],
        [2, 5, 8],
        [0, 4, 8],
        [2, 4, 6]
    ];

    for (let i = 0; i < lines.length; i++) {
        const [a, b, c] = lines[i];
        if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
            return {
                winner: squares[a],
                points: lines[i],
            };
        }
    }

    return {
        winner: null,
        points: lines,
    };
}